import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Section, showAlert } from '@platform/ui';
import { SEO } from '@platform/seo';
import { buildSeo } from '@/shared/seo/seoBuilder';
import { PATHS } from '@/shared/constants/app/routes.constant.ts';
import { useCreateInquiry } from '../api/use-inquiry.mutation.ts';
import { InquiryForm } from '../components/InquiryForm.tsx';
import type { CreateInquiryInput } from '../inquiry.type.ts';

/** 문의 작성. AuthGuard 하위 라우트. 등록 후 상세로 이동. */
export function InquiryWriteView() {
  const navigate = useNavigate();
  const createMutation = useCreateInquiry();

  const handleSubmit = useCallback(
    async (input: CreateInquiryInput) => {
      const created = await createMutation.mutateAsync(input);
      navigate(PATHS.inquiryDetail(created.id), { replace: true });
    },
    [createMutation, navigate],
  );

  const handleError = useCallback((message: string) => {
    void showAlert({ title: '알림', message, confirmText: '확인' });
  }, []);

  const seo = buildSeo({
    title: '문의하기',
    description: '1:1 문의를 남겨주세요.',
    path: PATHS.inquiryWrite(),
  });

  return (
    <>
      <SEO {...seo} />
      <main className="bg-white dark:bg-dark-base text-neutral-950 dark:text-neutral-100 antialiased">
        <Section spacing="default">
          <Container>
            <div className="mx-auto max-w-3xl pt-[100px] sm:pt-28">
              <header className="mb-8 border-b border-black/10 dark:border-white/10 pb-5">
                <span className="text-[12px] font-semibold uppercase tracking-[0.12em] text-neutral-950/40 dark:text-white/40">
                  SUPPORT
                </span>
                <h1 className="mt-2 text-3xl font-extrabold -tracking-[0.03em]">
                  문의하기
                </h1>
              </header>
              <InquiryForm
                onSubmit={handleSubmit}
                submitting={createMutation.isPending}
                onCancel={() => navigate(PATHS.SUPPORT_INQUIRIES)}
                onError={handleError}
              />
            </div>
          </Container>
        </Section>
      </main>
    </>
  );
}
